import { toast as xenithToast } from "@xenithlabs/xenith-ui";
import { Logger } from "./logger";

export function toast(options: Parameters<typeof xenithToast>[0]) {
  const messageType =
    options.theme === "destructive"
      ? "Error"
      : options.theme === "success"
        ? "Success"
        : "Debug";

  if (options.theme === "destructive") {
    Logger.error(
      new Error(
        `[${messageType}][toast] ${options.title || options.description}`,
      ),
      { description: options.description || "", titlte: options.title },
    );
  } else {
    Logger.info(
      `[${messageType}][toast] ${options.title || options.description}`,
      {
        description: options.description || "",
        titlte: options.title,
      },
    );
  }

  return xenithToast(options);
}
